import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'conn-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BlankComponent {
  constructor() {}
}
